import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { Text } from "@ui-kit/Text/Text";
import { colors } from "@ui-kit/ConfigProvider/ConfigProvider";
import { selectAuthView } from "@store/sessionReducer";
import { useAppSelector } from "@store/store";

interface AuthErrorProps {}

const AuthError: FunctionComponent<AuthErrorProps> = () => {
  const { t } = useTranslation();
  const view = useAppSelector(selectAuthView);

  return (
    <div className="auth-error">
      <Text variant="fontBodyLarge" color={colors.textDanger}>
        {t(`screens.auth.${view}.error`)}
      </Text>
    </div>
  );
};

export { AuthError };
